// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InboxOutlinedSvg from "@fishx/icons-svg/es/asn/InboxOutlined";
import FishxIcon from '../components/FishxIcon';

var InboxOutlined = function InboxOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InboxOutlinedSvg
  }));
};

InboxOutlined.displayName = 'InboxOutlined';
export default React.forwardRef(InboxOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InboxOutlined.js
// module id = 2961
// module chunks = 0